import { render, staticRenderFns } from "./page-bingo.vue?vue&type=template&id=363d7a4a&"
import script from "./page-bingo.vue?vue&type=script&lang=js&"
export * from "./page-bingo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports